import React from 'react';
import ReactDOM from 'react-dom';
import Root from './pages/root';

import { Provider } from "react-redux";
import store from "./store";

import './index.css';
require("./styles/global.scss");

const render = () => {
    ReactDOM.render(
        <Provider store={store}>
            <Root />
        </Provider>,
        document.getElementById("root")
    );
};

if ("serviceWorker" in navigator && navigator.userAgent.indexOf("Safari") < 0) {
	navigator.serviceWorker
		.register("/sw.js", { scope: "/" })
		.then(function(reg) {
            console.log("Registration succeeded. Scope is " + reg.scope);
            render();
		})
		.catch(function(error) {
            console.log("Registration failed with " + error);
            render();
		});
} else {
    render();
}

if (module.hot) {
    module.hot.accept("./pages/root", function() {
        render();
    });
}



// WEBPACK FOOTER //
// ./src/index.js